import { giphyDarkGrey, giphyLightestGrey } from '@giphy/colors'
import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

export const Container = styled.div`
    border-radius: inherit;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    position: relative;
    z-index: 1;

    > div {
        animation: ${fadeIn} 0.2s ease-out;
    }
`

export const Subheading = styled.h3`
    color: ${giphyLightestGrey};
    font-size: 16px;
    font-weight: bold;
    line-height: 18px;
    margin: 0 0 10px;
    text-align: left;

    > span {
        font-weight: normal;
    }

    > svg,
    > i {
        display: inline-block;
        vertical-align: text-top;

        &:last-child {
            margin: 0 0 0 8px;
        }

        &:first-child {
            margin: 0 8px 0 0;
        }
    }
`

export const Pill = styled.div`
    background: ${giphyDarkGrey};
    border-radius: 2px;
    color: #fff;
    flex-shrink: 0;
    font-size: 15px;
    padding: 2px;
`

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    padding: 20px 20px 30px;

    > h3 {
        grid-column: span 8;
    }
`

export const Toolbar = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    padding: 20px;
    position: relative;
    width: 100%;

    > h3 {
        margin: 0;
    }
`
